module.exports = __webpack_public_path__ + "img/title.8e428a84.png";